export enum GRANT_SECTION {
  TEST_MEASUREMENTS = 'Apollo',
  ANOMALY_DETECTION = 'AnomalyDetection',
  OWNER = 'Owner',
  ADMINISTRATION = 'Administration',
  UNIT = 'Unit',
  GLOBAL = 'Global',
  AGENT = 'Agent'
}
